import { bl_fi_deposit_txn_category_line_RowClass } from '../../dbschema/bl_fi_deposit_txn_category_line.model';
import { BaseContainerModel } from '../base-container.model';

export class DepositTxnCategoryLineContainerModel extends BaseContainerModel {
  bl_fi_deposit_txn_category_line: bl_fi_deposit_txn_category_line_RowClass = new bl_fi_deposit_txn_category_line_RowClass();
}
